import CRUD from './genericCRUD'

const route = 'varieties'

/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function varieties(instance) {
	return {
		/**
		 * CRUD creates the Create, Get, Update and GetALL endpoints;
		 */
		...CRUD(instance, route),

		/**
		 * @param {number} pageNumber
		 * @param {number} pageSize
		 * @param {string} name
		 * @param {string} code
		 * @param {number} number
		 * @param {number} breederId
		 * @param {number} commodityId
		 * @param {number} isActive
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAllpaged: (
			pageNumber,
			pageSize,
			name,
			code,
			number,
			breederId,
			commodityId,
			isActive,
			config = {}
		) => {
			const params =
				!!pageNumber && !!pageSize
					? `pageNumber=${pageNumber}&pageSize=${pageSize}&`
					: ''

			const nameParam = name ? `name=${name}&` : ''
			const numberParam = number ? `number=${number}&` : ''
			const codeParam = code ? `code=${code}&` : ''
			const breederParam = breederId ? `breederId=${breederId}&` : ''
			const commodityParam = commodityId ? `commodityId=${commodityId}&` : ''
			const isActiveParam = isActive ? `isActive=${isActive}&` : ''

			return instance.get(
				`${route}?${params}${nameParam}${codeParam}${numberParam}${breederParam}${commodityParam}${isActiveParam}`,
				config
			)
		},

		/**
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		update: (body, config = {}) => {
			return instance.put(`${route}`, body, config)
		}
	}
}
